import { render, staticRenderFns } from "./UwmNotes.vue?vue&type=template&id=1df3569a&scoped=true&"
import script from "./UwmNotes.vue?vue&type=script&lang=js&"
export * from "./UwmNotes.vue?vue&type=script&lang=js&"
import style0 from "./UwmNotes.vue?vue&type=style&index=0&id=1df3569a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3569a",
  null
  
)

export default component.exports